import React, { Component } from "react";
import HcsStatic from "./hcs-static";
import HcsButtonGroupNext from "./hcs-buttongroupnext";
import HcsSubconfigFinish from "./hcs-subconfig-finish";
import HcsImageSelect from "./hcs-imageselect";
import HcsRadioSelect from "./hcs-radioselect";
import HcsSelect from "./hcs-select";
import HcsTextArea from "./hcs-textarea";
import HcsEdit from "./hcs-edit";
import HcsNumberInput from "./hcs-number-input";
import HcsNumberInputCheck from "./hcs-number-input-check";
import HcsInlineError from "./hcs-inlineerror";
import HcsSubConfig from "./hcs-subconfig";
import HcsSubConfigInline from "./hcs-subconfig-inline";
import HcsSubConfigTopMenu from "./hcs-subconfig-top-menu";
import HcsDragItems from "./hcs-dragitems";
import HcsButtonShoppingCart from "./hcs-button-shoppingcart";
import HcsImageButtonGroup from "./hcs-imagebuttongroup";
import HcsButtonSaveConfiguration from "./hcs-button-saveconfiguration";
import HcsSwitch from "./hcs-switch";
import HcsNavi from "./hcs-navi";
import { ConfigurationModes } from "./hcs-constants";


export default class HcsGroup extends Component {
    constructor(props) {
        super(props);

        this.changeGroup = this.changeGroup.bind(this);
        this.subConfigFinish = this.subConfigFinish.bind(this);
    }

    changeGroup(groupId, sender) {
        this.props.onGroupChanged(groupId, sender);
    }

    subConfigFinish() {
        //this.props.onConfig("exitCurrentCfgObject", null, null, { accept: true });
        this.props.onConfig("exitCurrentCfgObject", null, null);
    }

    getComponent(groupData, cfgItem) {
        // Common properties which will be assigned to all controls.
        let commonProps = {
            key: `hcs-ctrl-${cfgItem.ident}`,
            groupData: groupData,
            data: cfgItem,
            hcs: this.props.hcs,
            onConfig: this.props.onConfig,
            configWait: this.props.configWait,
            checkValueChange: this.props.checkValueChange,
            progressState: this.props.progressState
        };

        switch(cfgItem.info.type) {
            case "static":
                return (
                    <HcsStatic
                        {...commonProps}
                    />);

            case "select":
                switch(cfgItem.data.CONTROL_TYPE) {
                    case "DRAG_DROP":
                        return (
                            <HcsDragItems
                                {...commonProps}
                            />);

                    // case "DRAG_DROP_MULTI":
                    //     return null;

                    case "THUMB_H":
                        switch(cfgItem.data.CFG_CONTROL) {
                            case "LIST":
                                return (
                                    <HcsImageButtonGroup
                                        {...commonProps}
                                        type="list"
                                    />);

                            case "SMALL":
                                return (
                                    <HcsImageSelect
                                        {...commonProps}
                                        type="small"
                                    />);

                            default:
                                return (
                                    <HcsImageSelect
                                        {...commonProps}
                                        type="default"
                                    />);
                        }

                    case "RADIO_H":
                    case "RADIO_D":
                        return (
                            <HcsRadioSelect
                                {...commonProps}
                            />);

                    case "SWITCH":
                        return (
                            <HcsSwitch
                                {...commonProps}
                            />);

                    default:
                        return (
                            <HcsSelect
                                {...commonProps}
                            />);
                }

            case "multiselect":
                switch(cfgItem.data.CONTROL_TYPE) {
                    case "BUTTON":
                        switch(cfgItem.data.CFG_CONTROL) {
                            case "CTRL_NAVI":
                                return (
                                    <HcsNavi
                                        {...commonProps}
                                        onGroupChanged={groupId => this.changeGroup(groupId, cfgItem.data.CFG_CONTROL)}
                                    />);

                            case "CTRL_NEXT":
                                return (
                                    <HcsButtonGroupNext
                                        {...commonProps}
                                        onGroupChanged={groupId => this.changeGroup(groupId, cfgItem.data.CFG_CONTROL)}
                                    />);

                            case "CTRL_CFG_FINISH":
                                return (
                                    <HcsSubconfigFinish
                                        {...commonProps}
                                        onGroupChanged={groupId => this.changeGroup(groupId, cfgItem.data.CFG_CONTROL)}
                                    />);

                            case "CTRL_SHOPPING_CART":
                                return (
                                    <HcsButtonShoppingCart
                                        {...commonProps}
                                    />);

                            case "CTRL_SAVE_CONFIGURATION":
                                return (
                                    <HcsButtonSaveConfiguration
                                        {...commonProps}
                                    />);

                            default:
                                if(cfgItem.values && cfgItem.values.length > 0) {
                                    return (
                                        <HcsImageButtonGroup
                                            {...commonProps}
                                            type="thumbs"
                                        />);
                                }

                                return null;
                        }
                        return null;

                    case "CHECK_H":
                        switch(cfgItem.data.CFG_CONTROL) {
                            case "NUMBER_INPUT":
                                return (
                                    <HcsNumberInputCheck
                                        {...commonProps}
                                    />);

                            default:
                                return null;
                        }

                }
                break;

            case "edit":
                switch(cfgItem.data.CONTROL_TYPE) {
                    case "TEXTAREA":
                        return (
                            <HcsTextArea
                                {...commonProps}
                            />);

                    case "EDIT":
                        switch(cfgItem.data.CFG_CONTROL) {
                            case "NUMBER_INPUT":
                                return (
                                    <HcsNumberInput
                                        {...commonProps}
                                    />);

                            default:
                                return (
                                    <HcsEdit
                                        {...commonProps}
                                    />);
                        }
                }

            case "objlist":
                switch(cfgItem.data.CFG_CONTROL) {
                    case "HIDDEN":
                        return null;

                    // Same cas "COMPLEX" but we keep the nav structure of
                    // the main configuration.
                    case "DEFAULT":
                        return (
                            <HcsSubConfigTopMenu
                                {...commonProps}
                            />);

                    // Default subconfiguration behavior.
                    // When user clicks a subconfig item we enter it
                    // by calling "enterSubCfgObject"
                    case "COMPLEX":
                        return (
                            <HcsSubConfig
                                {...commonProps}
                            />);
                        
                    // Show subconfiguration directly without
                    // entering the subconfig item.
                    default:
                        return (
                            <HcsSubConfigInline
                                {...commonProps}
                            />);
                }

            case "internal":
                return null;

            default: {
                let errorMessage = "Not implemented CFG element: " + cfgItem.info.type;

                console.error(errorMessage);
                return <HcsInlineError data={cfgItem} text={errorMessage} />;
            }
        }
    }

    isVisible() {
        const { data } = this.props;

        var groupVisible = false;

        data.attributes.forEach(function(element) {
            groupVisible |= element.info.visible;
        });

        return groupVisible;
    }

    componentDidMount() {
        this.postRender();
    }

    componentDidUpdate() {
        this.postRender();
    }

    postRender() {
        const { data, currentGroup, hcs, subConfigInfo } = this.props;

        let scrollContainer = this.props.hcs.api.instance(".hcs-wrapper");

        // Search for "Next" button and add special class to wrapper container
        // We use this to maintain config scroll container size
        // wether there is a "Next" button or not.
        // In case of a "Next" button we must reserve some space at the bottom,
        // without this button we can use the full height.
        if(this.isVisible() && currentGroup === data.groupId) {
            let groupHasNextButton = data.attributes.find(cfgItem =>
                cfgItem.info.type === "multiselect" &&
                cfgItem.data.CONTROL_TYPE === "BUTTON" &&
                ["CTRL_NEXT", "CTRL_NAVI", "CTRL_CFG_FINISH"].includes(cfgItem.data.CFG_CONTROL)
            );

            let isSubConfigInline = subConfigInfo.subConfigMode === ConfigurationModes.SubConfigurationInline;
            let oldState = scrollContainer.classList.contains("hcs-next");
            let hasNextButton = typeof groupHasNextButton !== "undefined";

            if(hasNextButton) {
                scrollContainer.classList.add("hcs-next");
            } else {
                if(!isSubConfigInline) {
                    // Keep "hcs-next" state from outer configuration and do not remove this class when
                    // we are currently in an inliune subconfiguration.
                    // see also: https://app.asana.com/0/1124801794043738/1199525563741728/f
                    scrollContainer.classList.remove("hcs-next");
                } else {
                    //console.info("NOT REMOVE");
                }
            }

            if(oldState !== hasNextButton) {
                hcs.ui.configScrollbarUpdate();
            }

            hcs.cfgEngine.configurationPostRender(data, currentGroup);
        }
    }

    render() {
        const { data, groupIndex, currentGroup } = this.props;

        if(this.isVisible() && currentGroup === data.groupId) {
            return (
                <>
                    <h2>
                        <a onClick={this.subConfigFinish}><span>{data.groupTrans}</span></a>
                        <em>{groupIndex}</em><span>{data.groupTrans}</span>
                    </h2>
                    <ul>
                        {data.attributes.map((cfgItem, index) =>
                            this.getComponent(data, cfgItem)
                        )}
                    </ul>
                </>
            );
        } else {
            return null;
        }
    }
}
